import { PostModal } from 'components/collections/Post'
import { useSession } from 'context/Session'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
// import { Modal } from 'components/elements'
// import AuthSteps from 'components/collections/AuthSteps'

import * as S from './Dashboard.styles'
import Header from './Header/Header'

const defaultProps = {}
const propTypes = {}

export const Dashboard = props => {
  // const [isOpen, setOpen] = useState(false)
  // const [stepsConfig, setStepsConfig] = useState({})
  const router = useRouter()
  const { user, loadProfile } = useSession()
  const [lastRoute, setLastRoute] = useState(null)

  const { postData } = props
  const { post } = router.query

  // const { profile } = user || {}

  // useEffect(() => {
  //   if (
  //     profile &&
  //     user &&
  //     (!user?.isProfileComplete || !user?.isEmailConfirmed)
  //   ) {
  //     setStepsConfig({
  //       defaultStep: !user?.isProfileComplete ? 'setup' : 'welcome',
  //       defaultValues: profile,
  //     })
  //     setOpen(true)
  //   }
  // }, [user?.userId, profile?.profileImage])

  useEffect(() => {
    if (!user) {
      router.push('/')
    }
    if (user?.profile && !user?.profile?.singleLineStatement) {
      loadProfile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onPostClose = () => {
    router.push(lastRoute || '/dashboard', undefined, {
      shallow: false,
    })
  }

  const onPostOpen = () => {
    setLastRoute('/dashboard')
  }

  return !user ? null : (
    <S.Container>
      {post && (
        <PostModal postId={post} data={postData} onClose={onPostClose} />
      )}
      <Header />
      {!post && (
        <S.Content>
          <S.ArticleTabs {...props} onPostOpen={onPostOpen} />
        </S.Content>
      )}
      {/* <Modal
        isOpen={isOpen}
        close={() => setOpen(false)}
        closeOnOutside={false}
      >
        <AuthSteps {...stepsConfig} />
      </Modal> */}
    </S.Container>
  )
}

Dashboard.defaultProps = defaultProps
Dashboard.propTypes = propTypes

export default Dashboard
